import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fnlexgbfsnlswfchopes.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZubGV4Z2Jmc25sc3dmY2hvcGVzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTcxOTY0OTYsImV4cCI6MjAzMjc3MjQ5Nn0.wlulsbGSnzd-QQyxz6lILcJX4FDx6gnsPVOE0f07Jss';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);